import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { EditReccurrenceForm } from "../EditReccurrenceForm/EditReccurrenceForm.logic";
import {
  ButtonGroup,
  Button,
  Dialog,
  DialogInner,
  DialogHeader,
  DialogContent,
  DialogFooter
} from "../../../Common/UI/Index";
import { ButtonVariantType } from "../../../Common/UI/Types";
import "./Style.scss";

interface SchedulingPopupProps {
  /**
   * Title for the dialog box
   */
  title: string;
  /**
   * Action on close dialog
   */
  onCloseDialog: () => void;
  /**
   * Action on Save dialog
   */
  onSaveDialog: () => void;
  /**
   * Is save allowed
   */
  isSaveEnabled: boolean;
}

/**
 * Responsible to render scheduling popup
 */
export const SchedulingPopupView: React.FC<SchedulingPopupProps> = (props: SchedulingPopupProps) => {
  const { onCloseDialog, onSaveDialog, isSaveEnabled } = props;
  const { t: translate } = useTranslation();

  return (
    <div id="ebt-schedule-popup-dialog">
      <Dialog
        open={true}
        onOpenChange={onCloseDialog}
        preventBackdropClose={true}
        className="ebt-schedule-popup-dialog"
      >
        <DialogInner className="ebt-schedule-popup-dialog-inner">
          <DialogHeader
            className="ebt-recurrence-header"
          >
            <div>
              {translate("Scheduling.Heading.EditRecurrence")}
            </div>
          </DialogHeader>
          <DialogContent className="ebt-schedule-recurrence">
            <EditReccurrenceForm />
          </DialogContent>
          <DialogFooter>
            <ButtonGroup>
              <Button
                borderless={true}
                onClick={onCloseDialog}
              >
                {translate("Button.Cancel")}
              </Button>
              <Button
                variant={ButtonVariantType.FILLED}
                onClick={onSaveDialog}
                disabled={!isSaveEnabled}
              >
                {translate("Button.Save")}
              </Button>
            </ButtonGroup>
          </DialogFooter>
        </DialogInner>
      </Dialog>
    </div>
  );
};
